import { useState } from "react";

import useRefundToolData from "../../state/refundTool/UseRefundToolData";

const INITIAL_REFUND_ERROR_STATE = {
  isError: false,
  errorMessage: ''
};

const useRefundTool = () => {
  const { refundToolState, getPaymentRefund, postPaymentRefund, resetRefundToolState } = useRefundToolData();
  const [refundErrorState, setRefundErrorState] = useState(INITIAL_REFUND_ERROR_STATE);

  const onSearchFormSubmit = (formState) => {
    if (formState.receiptNumber) {
      const getPaymentRefundPromise = getPaymentRefund(formState.receiptNumber.trim());

      if (getPaymentRefundPromise ?? false) {
        getPaymentRefundPromise.catch((e) => {
          setRefundErrorState({
            ...refundErrorState,
            isError: true,
            errorMessage: e.message
          });
        });
      }
    }
  };

  const onGridFormSubmit = (formState) => {
    if (formState.itemsToRefund.length > 0 && refundToolState.receiptNumber) {
      const postPaymentRefundPromise = postPaymentRefund(refundToolState.receiptNumber, formState.itemsToRefund);

      if (postPaymentRefundPromise ?? false) {
        postPaymentRefundPromise.catch((e) => {
          setRefundErrorState({
            ...refundErrorState,
            isError: true,
            errorMessage: e.message
          });
        });
      }
    }
  };

  const onCloseErrorPopupClicked = () => {
    resetRefundToolState();

    setRefundErrorState(INITIAL_REFUND_ERROR_STATE);
  };

  const onClearSearchClicked = () => {
    resetRefundToolState();
  };

  return {
    isLoading: refundToolState.isObjLoading,
    transactionObj: refundToolState.isObjLoaded === true ? refundToolState.objData : null,
    refundErrorState,
    onSearchFormSubmit,
    onGridFormSubmit,
    onClearSearchClicked,
    onCloseErrorPopupClicked
  };
};

export default useRefundTool;